import React from 'react';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';

interface ErrorTextProps {
    children: string;
}

const ErrorText: React.FC<React.PropsWithChildren<ErrorTextProps>> = ({
    children,
}) => {
    return <Text>{children}</Text>;
};

export default ErrorText;

const Text = styled.p({
    color: aampeTheme.colors.error500,
    fontSize: '14px',
    border: `1px solid ${aampeTheme.colors.error500}`,
    borderRadius: aampeTheme.borderRadius.default,
    padding: aampeTheme.spacing(0, 1),
});
